module.exports = __webpack_public_path__ + "cf9df6886c6f3bb6b50bb402040a4d82.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/badass-origins-intro.jpg
// module id = 514
// module chunks = 0